
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";
import ndr from "../assets/images/icons/NDRManagement.svg";
import WeightReconcillation from "../assets/images/icons/WeightReconcillation.svg";
import cod from "../assets/images/icons/cod.svg";
import Pickup from "../assets/images/icons/MultipleLocationPickup.svg";
import MultipleShippingPartners from "../assets/images/icons/MultipleShippingPartners.svg";
import Calculator from "../assets/images/icons/Calculator.svg";
import APIIntegration from "../assets/images/icons/APIIntegration.svg";
import solutions_banner from "../assets/images/icons/solutions_banner.svg";
import Contactus from "../assets/images/icons/Contactus.svg";
import FAQs from "../assets/images/icons/FAQs.svg";
import Carrers from "../assets/images/icons/Carrers.svg";
import coupon from "../assets/images/icons/coupon.svg";
import resource_banner from "../assets/images/icons/resource_banner.svg";


const  Offcanvases = () => {
  return (
    <>

    <section className="off_canvas">
    {[false].map((expand) => (
        <Navbar key={expand} expand={expand} >
        
      
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <NavLink to="/">
                <img src={logo} alt="photo-error" className="trux-logo" />
              </NavLink>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                <NavLink to="/service" className="nav-link">
                  Services
                </NavLink>
                
                  <NavDropdown
                    title="Solutions"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                     <div className="solution_body">
                    <div className="solution_items">
                      <NavDropdown.Item>
                        <Link to="/ndr_managment">
                          {" "}
                          <img
                            src={ndr}
                            alt=""
                            srcset=""
                          />{" "}
                          NDR Management
                        </Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <Link to="/weightReconciliation">
                          <img
                            src={WeightReconcillation}
                            alt=""
                            srcset=""
                          />
                          Weight Reconciliation
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/cod_remittance">
                          <img
                            src={cod}
                            alt=""
                            srcset=""
                          />
                          Timely COD Remittance
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/multiple_pickup">
                          <img
                            src={Pickup}
                            alt=""
                            srcset=""
                          />
                          Multiple Pickup Locations
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/Multiple_ShippingPartner">
                          <img
                            src={MultipleShippingPartners}
                            alt=""
                            srcset=""
                          />
                          Multiple Shiping Partner
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/ShippingRateCalculator">
                          <img
                            src={Calculator}
                            alt=""
                            srcset=""
                          />
                          Shipping Rate Calculator
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <img
                          src={APIIntegration}
                          alt=""
                          srcset=""
                        />
                        <Link to="/ApiIntegration">API Integration</Link>
                      </NavDropdown.Item>
                    </div>
                    
                  </div>
                  </NavDropdown>
                  <NavLink to="/media" className="nav-link">
                 Media
                </NavLink>
                  <NavDropdown
                    title="Resources"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <div className="resource_body">
                    <div className="resource_items">
                      <NavDropdown.Item>
                        <Link to="/contactus">
                          <img
                            src={Contactus}
                            alt=""
                            srcset=""
                          />
                          Contact us
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/faq">
                          <img
                            src={FAQs}
                            alt=""
                            srcset=""
                          />
                          FAQ's
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/Career">
                          <img
                            src={Carrers}
                            alt=""
                            srcset=""
                          />
                          Career
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/shipment-coupons">
                          <img
                            src={coupon}
                            alt=""
                            srcset=""
                          />{" "}
                        Coupons
                        </Link>
                      </NavDropdown.Item>
                    </div>

                   
                  </div>
                  </NavDropdown>

                  <NavLink to="/about" className="nav-link">
                 About us
                </NavLink>
                <NavLink to="/track" className="nav-link">
                  Track Order
                </NavLink>
                <NavLink to="/blog" className="nav-link">
                  Blogs
                </NavLink>
                </Nav>
                <div className="logins-buttons mt-3">
                <Link
                  to="https://b2b.truxcargo.com/login"
                  
                >
                   <button className="outline-login " role="button">
                   Login
                   
                  </button>
                  
                </Link>
                <Link to="https://b2b.truxcargo.com/register/">
                  <button className=" button-reg" role="button">
                   Register for free
                    {/* <img src="/featured-icon/diagonal-arrow.png" alt="" /> */}
                  </button>
                </Link>

                <div className="solution_image">
                     <Link to="/contactus"> <img
                        src={resource_banner}
                        alt=""
                        srcset=""
                        className="w-100"
                      /></Link>
                    </div>

                    <div className="solution_image">
                     <Link to="/contactus"> <img
                        src={solutions_banner}
                        alt=""
                        srcset=""
                        className="w-100"
                      /></Link>
                    </div>
              </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          
        </Navbar>
      ))}
    </section>
   
    </>
  );
}

export default Offcanvases;